import {
  MODEL_TYPE
} from './model_types'
import enumConstants from './../enumConstants.json'

export const RESOURCE_PRICE_TYPE_TO_MODEL_TYPE = {
  [enumConstants.resource_price_types.RESOURCE]: MODEL_TYPE.RESOURCE,
  [enumConstants.resource_price_types.RESOURCE_GROUP]: MODEL_TYPE.RESOURCE_GROUP
}
